import { render, staticRenderFns } from "./CommissionConfigForm.vue?vue&type=template&id=414cfc2e&"
import script from "./CommissionConfigForm.vue?vue&type=script&lang=js&"
export * from "./CommissionConfigForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports